<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/question-set-e">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}} 
            </div>
        </div>
        <div class="content" v-for="(item,index) in data[loadIndex].question" :key="index">
            <div class="talent-category margin-bottom-10 text-left">
                {{item.section}}
            </div>
            <div v-for="(subitem,index) in item.question" :key="index">
                <div class="talent-left-wrapper">
                    <label class="talent-label text-left">
                        {{subitem.title}}
                    </label>
                </div>
                <div class="talent-right-wrapper">
                    <label v-if="item.section.toLowerCase()=='l' && subitem.index!='13'" :class="setl.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setl" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_g[]" @change="check(setl,'g')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='l' && subitem.index=='13'" class="talent-option talent-option-text total_number_g">
                        <input v-model="setl" class="custom-input-text total_number_g" type="number" name='total_number_g' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='t' && subitem.index!='13'" :class="sett.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="sett" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_e[]" @change="check(sett,'e')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='t' && subitem.index=='13'" class="talent-option talent-option-text total_number_e">
                        <input v-model="sett" class="custom-input-text total_number_e" type="number" name='total_number_e' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='p' && subitem.index!='12'" :class="setp.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setp" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_n[]" @change="check(setp,'n')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='p' && subitem.index=='12'" class="talent-option talent-option-text total_number_n">
                        <input v-model="setp" class="custom-input-text total_number_n" type="number" name='total_number_n' readonly>
                    </label>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="talent-button-wrapper">
            <a @click="proceed()" class="generali-button-red">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
export default {
    name: "Question_set_f",
    data(){
        return {
            setl: [],
            sett: [],
            setp: [],
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "III. Profession",
                "description": "Ignoring qualification requirements, put a tick ( ✔ ) in the box against those jobs that you think you can do well in.",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "Sociologist"
                    },{
                        "index": 2,
                        "title": "Secondary School Teacher"
                    },{
                        "index": 3,
                        "title": "Juvenile Delinquency Expert"
                    },{
                        "index": 4,
                        "title": "Speech Therapist"
                    },{
                        "index": 5,
                        "title": "Marriage Counselor"
                    },{
                        "index": 6,
                        "title": "School Principal"
                    },{
                        "index": 7,
                        "title": "Social Science Teacher"
                    },{
                        "index": 8,
                        "title": "Director of Welfare Agency"
                    },{
                        "index": 9,
                        "title": "Youth Camp Director"
                    },{
                        "index": 10,
                        "title": "Personal Counselor"
                    },{
                        "index": 11,
                        "title": "Psychiatric Case Worker"
                    },{
                        "index": 12,
                        "title": "Vocational Counselor"
                    },{
                        "index": 13,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "Currency Speculator"
                    },{
                        "index": 2,
                        "title": "Buyer"
                    },{
                        "index": 3,
                        "title": "Advertising Representative"
                    },{
                        "index": 4,
                        "title": "Manufacturers Representative"
                    },{
                        "index": 5,
                        "title": "Television Producer"
                    },{
                        "index": 6,
                        "title": "Hotel Manager"
                    },{
                        "index": 7,
                        "title": "Business Executive"
                    },{
                        "index": 8,
                        "title": "Restaurant Manager"
                    },{
                        "index": 9,
                        "title": "Master of Ceremonies"
                    },{
                        "index": 10,
                        "title": "Sales Representative"
                    },{
                        "index": 11,
                        "title": "Sports Promoter"
                    },{
                        "index": 12,
                        "title": "Sales Manager"
                    },{
                        "index": 13,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "Bookkeeper"
                    },{
                        "index": 2,
                        "title": "Business Teacher"
                    },{
                        "index": 3,
                        "title": "Budget Reviewer"
                    },{
                        "index": 4,
                        "title": "Certified Public Accountant"
                    },{
                        "index": 5,
                        "title": "Credit Investigator"
                    },{
                        "index": 6,
                        "title": "Court Stenographer"
                    },{
                        "index": 7,
                        "title": "Bank Teller"
                    },{
                        "index": 8,
                        "title": "Tax Expert"
                    },{
                        "index": 9,
                        "title": "Inventory Controller"
                    },{
                        "index": 10,
                        "title": "IT Technician"
                    },{
                        "index": 11,
                        "title": "Financial Analyst"
                    },{
                        "index": 12,
                        "title": "TOTAL no. of ticks"
                    }]
                }],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "III. 专业",
                "description": "不需要顾虑资格要求的问题， 在那些你觉得感兴趣的领域里画 ( ✔ )。 你可以选择超过一个。",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "社会学家"
                    },{
                        "index": 2,
                        "title": "中学老师"
                    },{
                        "index": 3,
                        "title": "少年犯罪专家"
                    },{
                        "index": 4,
                        "title": "语言治疗专家"
                    },{
                        "index": 5,
                        "title": "婚姻指导顾问"
                    },{
                        "index": 6,
                        "title": "校长"
                    },{
                        "index": 7,
                        "title": "社会科学老师"
                    },{
                        "index": 8,
                        "title": "福利部总监"
                    },{
                        "index": 9,
                        "title": "青年营总监"
                    },{
                        "index": 10,
                        "title": "私人顾问"
                    },{
                        "index": 11,
                        "title": "精神病个案社工"
                    },{
                        "index": 12,
                        "title": "职业辅导员"
                    },{
                        "index": 13,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "货币投机商"
                    },{
                        "index": 2,
                        "title": "买家"
                    },{
                        "index": 3,
                        "title": "广告业务代表"
                    },{
                        "index": 4,
                        "title": "制造商业务代表"
                    },{
                        "index": 5,
                        "title": "电视制作厂商"
                    },{
                        "index": 6,
                        "title": "酒店经理"
                    },{
                        "index": 7,
                        "title": "业务执行员"
                    },{
                        "index": 8,
                        "title": "餐馆经理"
                    },{
                        "index": 9,
                        "title": "司仪"
                    },{
                        "index": 10,
                        "title": "业务代表"
                    },{
                        "index": 11,
                        "title": "运动促销人员"
                    },{
                        "index": 12,
                        "title": "营销经理"
                    },{
                        "index": 13,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "记账员"
                    },{
                        "index": 2,
                        "title": "商业老师"
                    },{
                        "index": 3,
                        "title": "预算案评论家"
                    },{
                        "index": 4,
                        "title": "特许会计师"
                    },{
                        "index": 5,
                        "title": "货款调查员"
                    },{
                        "index": 6,
                        "title": "法庭速记员"
                    },{
                        "index": 7,
                        "title": "银行出纳员"
                    },{
                        "index": 8,
                        "title": "税务专家"
                    },{
                        "index": 9,
                        "title": "存货管理员"
                    },{
                        "index": 10,
                        "title": "资讯工艺技术员"
                    },{
                        "index": 11,
                        "title": "财务分析员"
                    },{
                        "index": 12,
                        "title": "✔ 的数量"
                    }]
                }],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "III. Profesion",
                "description": "Tidak mempedulikan keperluan kelayakan, sila tanda ( ✔ ) di dalam kotak terhadap kerja-kerja yang anda fikir boleh lakukan dengan cukup baik",
                "question": [{
                    "section": "L",
                    "question": [{
                        "index": 1,
                        "title": "Ahli Sosiologi"
                    },{
                        "index": 2,
                        "title": "Guru Sekolah Menengah"
                    },{
                        "index": 3,
                        "title": "Pakar Delikuensi Juvana"
                    },{
                        "index": 4,
                        "title": "Ahli Terapi Pertuturan"
                    },{
                        "index": 5,
                        "title": "Kaunselor Perkahwinan"
                    },{
                        "index": 6,
                        "title": "Pengetua Sekolah"
                    },{
                        "index": 7,
                        "title": "Guru Sosial Sains"
                    },{
                        "index": 8,
                        "title": "Pengarah Agensi Kebajikan"
                    },{
                        "index": 9,
                        "title": "Pengarah Kem Belia"
                    },{
                        "index": 10,
                        "title": "Kaunselor Peribadi"
                },{
                        "index": 11,
                        "title": "Pekerja Kes Psikiatri"
                    },{
                        "index": 12,
                        "title": "Kaunselor Vokasional"
                    },{
                        "index": 13,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "T",
                    "question": [{
                        "index": 1,
                        "title": "Spekulator Mata Wang"
                    },{
                        "index": 2,
                        "title": "Pembeli"
                    },{
                        "index": 3,
                        "title": "Wakil Pengiklanan"
                    },{
                        "index": 4,
                        "title": "Wakil Pengilang"
                    },{
                        "index": 5,
                        "title": "Penerbit Televisyen"
                    },{
                        "index": 6,
                        "title": "Pengurus Hotel"
                    },{
                        "index": 7,
                        "title": "Eksecutif Perniagaan"
                    },{
                        "index": 8,
                        "title": "Pengurus Perniagaan"
                    },{
                        "index": 9,
                        "title": "Juruacara Majlis"
                    },{
                        "index": 10,
                        "title": "Wakil Jualan"
                },{
                        "index": 11,
                        "title": "Penganjur Sukan"
                    },{
                        "index": 12,
                        "title": "Pengurus Jualan"
                    },{
                        "index": 13,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "P",
                    "question": [{
                        "index": 1,
                        "title": "Akauntan"
                    },{
                        "index": 2,
                        "title": "Guru Perniagaan"
                    },{
                        "index": 3,
                        "title": "Pengulas Bajet"
                    },{
                        "index": 4,
                        "title": "Akauntan Awam Bertauliah"
                    },{
                        "index": 5,
                        "title": "Penyiasat Kredit"
                    },{
                        "index": 6,
                        "title": "Jurutrengkas Mahkamah"
                    },{
                        "index": 7,
                        "title": "Juruwang Bank"
                    },{
                        "index": 8,
                        "title": "Pakar Cukai"
                    },{
                        "index": 9,
                        "title": "Pengawal Inventori"
                    },{
                        "index": 10,
                        "title": "Juruteknik IT"
                },{
                        "index": 11,
                        "title": "Penganalisis Kewangan"
                    },{
                        "index": 12,
                        "title": "Bilangan ✔"
                    }]
                }],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,setname) {
            this.$el.querySelector(".total_number_"+setname).innerText = set.length;
        },
        proceed(){
            this.conclusion.l3 = 0;
            this.conclusion.t3 = 0;
            this.conclusion.p3 = 0;

            if(this.setl.length > 0){
                for(var a = 0 ; a < this.setl.length; a++){
                    this.conclusion.l3 += 1;
                }   
            }
            if(this.sett.length > 0){
                for(var b = 0; b < this.sett.length; b++){
                    this.conclusion.t3 += 1;
                }
            }
            if(this.setp.length > 0){
                for(var c = 0; c < this.setp.length; c++){
                    this.conclusion.p3 += 1;
                }
            }
            console.log(this.conclusion)
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({path: 'question-set-g'})
        }
    }
}
</script>